import { CSSVars } from '@/styles/styles.config';
import styled from 'styled-components';

export const StyledPagination = styled.div`
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: center;
	margin-top: 30px;

	p.page-number {
		font-weight: 600;
		font-size: 14px;
		color: ${CSSVars.gray500};
		margin: 0;
		cursor: pointer;

		&.active {
			pointer-events: none;
			color: ${CSSVars.gray400};
		}
	}

	.pagination-icon {
		margin: 0;
		font-size: 10px;
		opacity: 0.7;
		cursor: pointer;

		polyline {
			stroke: ${CSSVars.gray300};
		}

		&.disable {
			pointer-events: none;
			opacity: 0.4;
		}
	}

	.double-prev-icon,
	.double-next-icon {
		display: flex;

		.pagination-icon {
			&:last-of-type {
				margin-left: -6px;
			}
		}
	}
`;
